import { useEffect, useRef, useState } from "react";
import spec from "@/constants/treeSpec.json";

export default function TreeLogo({ className = "h-28" }) {
  const [play, setPlay] = useState(false);
  const timer = useRef(null);
  const playing = useRef(false);
  const rootRef = useRef(null);

  const trigger = () => {
    if (playing.current) return;
    playing.current = true;
    setPlay(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      playing.current = false;
      setPlay(false);
    }, 3200 + spec.leaves.length * 150 + 300);
  };

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) trigger(); },
      { threshold: 0.6 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={rootRef}
      className={`relative cursor-pointer select-none ${play ? "leaves-play" : ""} ${className}`}
      style={{ aspectRatio: `${spec.width} / ${spec.height}` }}
      onClick={trigger}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); trigger(); } }}
      role="button"
      tabIndex={0}
      aria-label="Arbre Cœur d'École Toury Famille — touchez-le pour faire s'envoler les feuilles"
      data-testid="tree-logo"
    >
      <img src="/assets/tree/trunk.png" alt="" draggable={false} className="absolute inset-0 w-full h-full" />
      {spec.leaves.map((l, i) => (
        <img
          key={l.file}
          src={`/assets/tree/${l.file}`}
          alt=""
          draggable={false}
          className="tree-leaf-img absolute"
          style={{
            left: `${(l.x / spec.width) * 100}%`,
            top: `${(l.y / spec.height) * 100}%`,
            width: `${(l.w / spec.width) * 100}%`,
            animationDelay: `${i * 0.15}s`,
            "--dx": `${(i % 2 === 0 ? 1 : -1) * (16 + (i % 4) * 8)}px`,
          }}
        />
      ))}
    </div>
  );
}
